import { applyScheduleZoomCssVars } from './scheduleZoomCss';

export type ScheduleZoomCanvasParams = {
  courtCount: number;
  viewportWidth: number;
  slotCount: number;
};

type CanvasEntry = ScheduleZoomCanvasParams;

const canvasEntries = new Map<HTMLElement, CanvasEntry>();

export function registerScheduleZoomCanvas(
  el: HTMLElement | null,
  params: ScheduleZoomCanvasParams
): void {
  if (!el) return;
  canvasEntries.set(el, params);
}

export function unregisterScheduleZoomCanvas(el: HTMLElement | null): void {
  if (el) canvasEntries.delete(el);
}

export function updateScheduleZoomCanvasParams(
  el: HTMLElement,
  params: ScheduleZoomCanvasParams
): void {
  if (canvasEntries.has(el)) {
    canvasEntries.set(el, params);
  }
}

export function getScheduleZoomCanvasParams(
  el: HTMLElement
): ScheduleZoomCanvasParams | undefined {
  return canvasEntries.get(el);
}

export function applyLiveScheduleZoomCss(scale: number, columnWidth: number): void {
  for (const [el, params] of canvasEntries) {
    applyScheduleZoomCssVars(
      el,
      scale,
      columnWidth,
      params.courtCount,
      params.viewportWidth,
      params.slotCount
    );
  }
}
